import React, { useMemo } from 'react';
import Lightbox, { Slide } from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import Video from 'yet-another-react-lightbox/plugins/video';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/counter.css';

export interface MediaViewerItem {
  type: 'image' | 'video';
  src: string;
  thumbnailSrc?: string;
  width?: number;
  height?: number;
}

interface MediaViewerProps {
  items: MediaViewerItem[];
  open: boolean;
  index: number;
  onClose: () => void;
  onIndexChange?: (index: number) => void;
}

const toSlides = (items: MediaViewerItem[]): Slide[] =>
  items.map((item) => {
    if (item.type === 'video') {
      return {
        type: 'video',
        width: item.width || 1280,
        height: item.height || 720,
        poster: item.thumbnailSrc,
        sources: [{ src: item.src, type: 'video/mp4' }],
      };
    }

    return { src: item.src };
  });

const MediaViewer: React.FC<MediaViewerProps> = ({
  items,
  open,
  index,
  onClose,
  onIndexChange,
}) => {
  const slides = useMemo(() => toSlides(items), [items]);

  if (!items.length) {
    return null;
  }

  return (
    <Lightbox
      open={open}
      close={onClose}
      index={index}
      slides={slides}
      plugins={[Zoom, Counter, Video]}
      zoom={{ maxZoomPixelRatio: 3, scrollToZoom: true }}
      counter={{ container: { style: { top: 'unset', bottom: 0 } } }}
      controller={{ closeOnBackdropClick: true }}
      styles={{ container: { backgroundColor: 'rgba(0, 0, 0, 0.95)' } }}
      video={{ controls: true, playsInline: true }}
      on={{ view: ({ index: nextIndex }) => onIndexChange?.(nextIndex) }}
    />
  );
};

export default MediaViewer;
